import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=bf115460&scoped=true&"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=bf115460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf115460",
  null
  
)

export default component.exports